"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgAdminFeatureArea = void 0;
var base_feature_area_1 = require("./base-feature-area");
var OrgAdminFeatureArea = /** @class */ (function (_super) {
    __extends(OrgAdminFeatureArea, _super);
    function OrgAdminFeatureArea(orgPermissions, altEvalFn) {
        return _super.call(this, orgPermissions, altEvalFn) || this;
    }
    OrgAdminFeatureArea.prototype.execute = function (currentPermission, entityOptions) {
        var _this = this;
        return {
            action: function (action) {
                return _this._action(action, currentPermission, entityOptions);
            }
        };
    };
    OrgAdminFeatureArea.prototype._action = function (action, currentPermission, entityOptions) {
        currentPermission = __assign({ action: action, source: '*', target: '*' }, currentPermission);
        return _super.prototype.evalPermission.call(this, currentPermission, entityOptions);
    };
    return OrgAdminFeatureArea;
}(base_feature_area_1.BaseFeatureArea));
exports.OrgAdminFeatureArea = OrgAdminFeatureArea;
